import * as Sentry from '@sentry/react'
import {useEffect} from 'react'

import {useCurrentUser} from '../auth/use-current-user'
import {isSentryEnabled} from './is-sentry-enabled'

export function SyncSentryUser() {
    const user = useCurrentUser()

    useEffect(() => {
        if (!isSentryEnabled()) {
            return
        }

        if (user) {
            Sentry.setUser({id: user.id, email: user.email, name: user.name})
        } else {
            Sentry.setUser(null)
        }
    }, [user])

    return null
}
